import styles from "./Toast.module.scss";
import { CrossIcon } from "./assets/CrossIcon";
import { TipIcon } from "./assets/TipIcon";

type ToastType = "success" | "error" | "info";

interface ToastProps {
  type?: ToastType;
  message: string;
  onClose: () => void;
  isClosing: boolean;
}

export const Toast = ({
  type = "info",
  message,
  onClose,
  isClosing,
}: ToastProps) => {
  const icon =
    type === "error" ? (
      <CrossIcon />
    ) : (
      <TipIcon color={type === "success" ? "#9FD356" : "#3C91E6"} />
    );

  return (
    <div
      className={`${styles.toast} ${isClosing ? styles.fadeOut : ""}`}
      onClick={onClose}
    >
      <div className={styles.toastMessage}>
        {icon}
        <span>{message}</span>
      </div>
    </div>
  );
};
